import { Pipe } from '@angular/core';
var IsNullPipe = (function () {
    function IsNullPipe() {
    }
    IsNullPipe.prototype.transform = function (input) {
        return input === null;
    };
    return IsNullPipe;
}());
export { IsNullPipe };
IsNullPipe.decorators = [
    { type: Pipe, args: [{ name: 'isNull' },] },
];
/** @nocollapse */
IsNullPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=is-null.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-null.js
// module id = 229
// module chunks = 4